
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { ShieldCheck } from 'lucide-react';

interface SafetyFilterProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

export const SAFETY_RATINGS = [
  'Very Safe (9-10)',
  'Safe (7-8)',
  'Moderate (5-6)',
  'Exercise Caution (3-4)'
] as const;

export const SafetyFilter = ({ value, onChange }: SafetyFilterProps) => {
  return (
    <div className="space-y-3">
      <Label className="text-sm font-medium block">Safety Rating</Label>
      <Select value={value || ''} onValueChange={onChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select safety level">
            {value && (
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-gray-500" />
                <span>{value}</span>
              </div>
            )}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {SAFETY_RATINGS.map((rating) => (
            <SelectItem key={rating} value={rating}>
              <div className="flex items-center gap-2">
                <ShieldCheck className="w-4 h-4 text-gray-500" />
                <span>{rating}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
